import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconMasterCard = createIcon({
  viewBox: '0 0 32 24',
  path: (
    <>
      <defs>
        <path id="prefix__a" d="M0 0.05L9.997 0.05 9.997 12.382 0 12.382z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H32V24H0z" />
        <g transform="translate(1 2)">
          <rect width="30" height="20" fill="#F4F4F5" rx="2" />
          <g>
            <path
              fill="#F79E1B"
              d="M9.997 1.447c.271-.204.551-.395.85-.557.63-.343 1.3-.57 2.009-.683.433-.069.869-.089 1.304-.063 1.388.082 2.616.571 3.673 1.473.885.754 1.505 1.688 1.866 2.793.138.423.225.858.267 1.302.035.359.04.718.01 1.077-.106 1.26-.55 2.39-1.347 3.375-.834 1.03-1.894 1.724-3.173 2.082-.368.103-.743.168-1.124.198-.382.03-.764.031-1.144-.009-1.162-.122-2.21-.537-3.14-1.246l-.05-.037c-.006-.009-.007-.018-.002-.027.237-.198.461-.41.675-.633.368-.384.675-.814.928-1.282.33-.61.547-1.258.656-1.942.036-.223.054-.448.068-.675.048-.814-.08-1.602-.352-2.368-.238-.67-.586-1.28-1.041-1.827-.27-.324-.568-.62-.897-.884-.014-.012-.027-.024-.037-.04-.004-.01-.004-.018.001-.027"
              transform="translate(5 4)"
            />
            <g transform="translate(5 4) translate(0 .086)">
              <mask id="prefix__b" fill="#fff">
                <use xlinkHref="#prefix__a" />
              </mask>
              <path
                fill="#EB001B"
                d="M9.997 11.048v.017c-.674.525-1.423.899-2.251 1.116-.65.17-1.312.234-1.98.184-1.575-.116-2.921-.736-4.023-1.864C.877 9.614.333 8.554.105 7.336.005 6.8-.025 6.262.02 5.72.214 3.344 1.727 1.4 3.77.534 4.304.309 4.857.155 5.43.093 7.113-.091 8.634.32 9.982 1.35l.015.01v.015c-.062.1-.166.156-.25.233-.335.303-.644.63-.91.996-.574.793-.94 1.673-1.096 2.638-.036.224-.054.449-.067.675-.044.74.06 1.458.282 2.161.233.741.599 1.411 1.092 2.012.261.319.553.608.87.873.03.024.067.042.079.084"
                mask="url(#prefix__b)"
              />
            </g>
            <path
              fill="#FF5F00"
              d="M9.997 11.134c-.06-.025-.104-.073-.153-.113-.225-.188-.435-.394-.63-.612-.299-.33-.558-.69-.776-1.08-.196-.348-.36-.71-.486-1.09-.108-.326-.19-.66-.24-1-.034-.223-.059-.447-.063-.674-.003-.114-.019-.229-.012-.343.014-.22.022-.439.048-.657.036-.288.09-.57.163-.85.081-.308.188-.606.315-.896.152-.35.338-.682.553-.997.138-.202.29-.393.45-.578.152-.174.316-.334.483-.492.11-.104.22-.206.348-.29.082.052.153.117.227.179.15.127.286.27.425.408.193.191.364.403.525.621.199.27.37.558.522.857.225.44.39.902.501 1.382.05.213.09.429.113.648.017.158.033.316.037.476.002.075.015.15.015.225 0 .199-.019.397-.034.595-.011.153-.032.304-.056.456-.043.27-.107.536-.186.799-.117.385-.274.754-.464 1.108-.172.32-.373.619-.597.905-.214.275-.462.519-.713.759-.097.093-.195.189-.315.254"
              transform="translate(5 4)"
            />
          </g>
        </g>
      </g>
    </>
  ),
});

export default IconMasterCard;
